export default class AdminPatients {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.adminPatientsEndpoint, {
      params
    })
  }

  fetch(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminPatientsEndpoint}/${id}`, {})
  }

  isOnline(user_id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminPatientsEndpoint}/${user_id}/online-status`)
  }

  export(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminPatientsEndpoint}/export/all`, {
      params,
      responseType: "blob"
    })
  }

  create(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.adminPatientsEndpoint}`, payload)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminPatientsEndpoint}/${id}/update`, payload, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
  }

  updateMedicalHistory(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminPatientsEndpoint}/${id}/medical-history`, payload, {})
  }

  fetchMedicalSummary(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminPatientsEndpoint}/${id}/medical-summary`, {})
  }

  issueExcuseDuty(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminPatientsEndpoint}/${id}/issue-excuse-duty`, payload, {})
  }
}
